import React, { Fragment } from 'react';

import Head from 'next/head';

import { withEventScope } from '@repo/event-processor';
import { buildWebsiteUrl } from '@repo/utils/url';

import Layout from 'components/Layout/Layout';
import { allStrapiComponentsMap } from 'strapi/allStrapiComponents';
import { ComponentToRenderResult } from 'strapi/types';

const LandingPageStrapiV2 = ({
  allComponentData,
}: {
  allComponentData: ComponentToRenderResult[];
}) => {
  return (
    <Layout newBackground={true}>
      <Head>
        {/* Facebook, Open Graph protocol */}
        <meta key="og:type" content="article" property="og:type" />
        <meta key="og:url" content={buildWebsiteUrl()} property="og:url" />
      </Head>
      {allComponentData.map(({ component, data }) => {
        return (
          <Fragment key={`${component.component_type}_${component.field}`}>
            {allStrapiComponentsMap[component.component_type].render(
              data,
              component
            )}
          </Fragment>
        );
      })}
    </Layout>
  );
};
export default withEventScope(LandingPageStrapiV2, {
  page: 'landingPageStrapi',
});
